module.exports = __webpack_public_path__ + "static/kenku-AYAGWW-b4ba6b2643f5cc259d61ead6c63072ea.jpg";